(() => {
    document.addEventListener("DOMContentLoaded", function () {

        const $get = id => document.getElementById(id);

        const oldTable = $get("oldTable");
        if (oldTable !== undefined && oldTable !== null) oldTable.style.display = "none";

        const tJsonW = $get("JSONWidths") as HTMLTextAreaElement;
        let leadInTapers = JSON.parse(tJsonW.value);

        if (leadInTapers === undefined) {
            leadInTapers = ["1m", "2m", "3m", "4m", "5m", "6m", "7m"];
        }

        const tJson = $get("JSONData") as HTMLTextAreaElement;
        const settingOutData = tJson.value;
        
        const allData = JSON.parse(settingOutData);
        const roadTypes: string[] = [];

        for (const x in allData) {
            roadTypes.push(allData[x].TypeOfRoad);
        }

        const container = $get("mainTable");

        let innerHTML = `
            <div class="row">
                <div class="form-group col-lg-7 mt-2 mb-1">
                    <label for="roadTypeDropdown">Type of road</label>
                    <div>
                        <span id="roadTypeDropdown"> </span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-lg-7 mt-2">
                    <label for="">Width of Works</label><br />

                        `;

        leadInTapers.forEach((x) =>
            innerHTML += `<input style="margin-left: 7px" type="checkbox" name="ww" value="${x}" />&nbsp;${x} `
        );

        innerHTML += `
                    
               </div>
            </div>
            <div class="row mt-1">
                <div class="form-group col-lg-7 mt-1">
                    <button id="btnShowRequirements"
                                name="command"
                                value="search"
                                type="submit"
                                class="ml-1 mt-2 btn btn-primary">
                            Show requirements
                    </button>
                </div>
           </div>


            <div id="tblRequirements" class="mt-3"></div>
        `

        container.innerHTML = innerHTML;

        const roadTypeSelect = document.createElement("select");
        roadTypeSelect.id = "roadTypeSelect";
        roadTypeSelect.className += "ml-1 form-control"; 
        $get("roadTypeDropdown").appendChild(roadTypeSelect);

        const defaultOption = document.createElement("option");
        defaultOption.value = "-1";
        defaultOption.text  = "Please select...";
        roadTypeSelect.appendChild(defaultOption);

        for (let i = 0; i < roadTypes.length; i++) {
            const option = document.createElement("option");
            option.value = String(i);
            option.text  = roadTypes[i];
            roadTypeSelect .appendChild(option);
        }

        const btnShowRequirementsClick = function (event) {
            const e   = $get("roadTypeSelect") as HTMLSelectElement;
            const sel = e.selectedIndex;
            const opt = e.options[sel];
            const rtValue: number = + opt.value;

            const dataRow = allData[rtValue];

            const lValues: string[] = [];

            $("input:checkbox[name=ww]:checked").each(function () {
                lValues.push(String($(this).val()));
            });

            const invalidSelection = rtValue === -1 || lValues.length === 0;

            if (!invalidSelection) {

                let txt = `
<style>
.table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
   background-color: #e0e0ef;
}
table.table-striped td {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
}

table.table-striped td:first-child {
    border-left: none;
}

table.table-striped td:last-child {
    border-right: none;
}

table.table-striped th {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
}

table.table-striped th:first-child {
    border-left: none;
}

table.table-striped th:last-child {
    border-right: none;
}

</style>
        <table role="table" class="table table-striped table-responsive mt-4">
            <thead>
            <tr>
            <th>Key</th>`;

                lValues.forEach((x) =>
                    txt += `<th>Width of Works: ${x}</th>`
                );


                txt += `
            </tr>
            </thead>
            <tbody>

            <tr>
            <td>Type of road</td>`;

                lValues.forEach(() =>
                    txt += `<td>${dataRow.TypeOfRoad}</td>`
                );


                txt += `
            </tr>
            <tr>
            <td>Minimum visibility distance to first sign</td>`;

                lValues.forEach(() =>
                    txt += `<td>${dataRow.MinimumVisibilityDistance}</td>`
                );


                txt += `
            </tr>
            <tr>
            <td>Distance from first sign to start of lead-in taper (<b>D</b>)</td>`;

                lValues.forEach(() =>
                    txt += `<td>${dataRow.DistanceFromFirstSign}</td>`
                );


                txt += `
            </tr>
            <tr>
            <td>Taper length (<b>T</b>)</td>`;


                lValues.forEach((x) =>
                    txt += `<td>${dataRow.TaperLength.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>
            <tr>
            <td>Number of cones</td>`;

                lValues.forEach((x) =>
                    txt += `<td>${dataRow.NoOfCones.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>
            <tr>
            <td>Number of lights</td>`;

                lValues.forEach((x) =>
                    txt += `<td>${dataRow.NoOfLights.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>
            <tr>
            <td>Minimum width of sideways safety zone (<b>S</b>)</td>`;

                lValues.forEach((x) =>
                    txt += `<td>${dataRow.MinimumWidthSideways}</td>`
                );

                txt += `
            </tr>

            <tr>
            <td>Distance from last cone to End of works sign (<b>E</b>)</td>`;
                lValues.forEach((x) =>
                    txt += `<td>${dataRow.DistanceFromLastCone}</td>`
                );

                txt += `
            </tr>

            <tr>
            <td>Minimum size of signs (mm)</td>`;
                lValues.forEach((x) =>
                    txt += `<td>${dataRow.MinimumSizeSigns}</td>`
                );

                txt += `

            </tr>

            <tr>
            <td>Longways clearance (<b>L</b>)</td>`;

                lValues.forEach((x) =>
                    txt += `<td>${dataRow.LongwaysClearance}</td>`
                );

                txt += `

            </tr>

            <tr>
            <td>Clearance to works vehicle (<b>C</b>)</td>`;
                lValues.forEach((x) =>
                    txt += `<td>${dataRow.ClearanceToWorksVehicle}</td>`
                );

                txt += `

            </tr>

            <tr>
            <td>Minimum height of cones (mm)</td>`;

                lValues.forEach((x) =>
                    txt += `<td>${dataRow.MinimumConeHeight}</td>`
                );

                txt += `
            </tr>

            </tbody>
            </table>
`;

                $get("tblRequirements").innerHTML = txt;
            }
            else {
                $get("tblRequirements").innerHTML = "";
            }

            switch (rtValue) {
                case 0: {
                    $("#FooterNotes").show();
                    $(".30mphNote").show();
                    break;
                }
                case 1: {
                    $("#FooterNotes").show();
                    $(".30mphNote").hide();
                    break;
                }
                case 2: {
                    $("#FooterNotes").show();
                    $(".30mphNote").hide();
                    break;
                }
                case 3: {
                    $("#FooterNotes").show();
                    $(".30mphNote").show();
                    break;
                }
                default: {
                    $(".30mphNote").hide();
                    $("#FooterNotes").hide();
                    break;
                }
            } 

        };

        $get("btnShowRequirements").addEventListener("click", btnShowRequirementsClick);

    });

})();


